export default __webpack_public_path__ + "static/media/error.48633784.png";